module.exports = __webpack_public_path__ + "static/media/Rove - Itinerary Details - 22 March 2023.c73f7481.mp4";